<template>
  <!-- 法律条例分类列表 -->
  <div class="tiaoliifyui ">
    <div class="cont between">
      <div class="left">
        <ifilawtj />
        <!-- <ifizxfg class="mt30" /> -->
        <tlifiulcont class="mt30" :cat_id="cat_id" />
      </div>
      <div class="righ">
        <ifisea />
        <ifirmfg class="mt30" />
        <ifionlinezx class="ifionlinezx mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import ifilawtj from "views/tiaoliify/components/ifilawtj";
import ifizxfg from "views/tiaoliify/components/ifizxfg";
import ifisea from "views/tiaoliify/components/ifisea";
import ifirmfg from "views/tiaoliify/components/ifirmfg";
import ifionlinezx from "./components/tiaolionline";
import tlifiulcont from "./child/tlifiulcont";
export default {
  name: "tiaoliifyui",
  components: {
    ifilawtj,
    ifizxfg,
    ifisea,
    ifirmfg,
    ifionlinezx,
    tlifiulcont,
  },
  data: () => ({
    cat_id: 0,
  }),
  beforeMount() {
    this.cat_id = this.$route.query.id;
  },
};
</script>

<style lang="scss" scoped>
.tiaoliifyui {
  width: 100%;

  background: #f8f8f8;
  .cont {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    align-items: flex-start;
    .left {
      width: 856px;
    }
    .righ {
      width: 314px;
      .ifionlinezx {
        width: 314px;
        height: 318px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>